import {
  MENU_REQUEST,
  MENU_SUCCESS,
  MENU_FAIL,
} from "../actions/menuActions";


const initialState = {
  loading: false,
  categories: [],
  restaurantId: null,
  restaurantName: "",
  error: null,
};


const menuReducer = (state = initialState, action) => {

  switch (action.type) {

    case MENU_REQUEST:

      return {
        ...state,
        loading: true,
        error: null,
      };


    case MENU_SUCCESS:

      return {
        ...state,
        loading: false,
        categories: action.payload.categories || [],
        restaurantId: action.payload.restaurant_id,
        restaurantName: action.payload.restaurant_name || "",
        error: null,
      };


    case MENU_FAIL:

      return {
        ...state,
        loading: false,
        error: action.payload,
      };


    default:

      return state;
  }

};


export default menuReducer;